import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-yes-no-cancel-component',
  templateUrl: './yes-no-cancel-component.component.html',
  styles: [
  ]
})
export class YesNoCancelComponentComponent implements OnInit {

  title: string = null;
  prompt: string = 'Are you sure?';

  constructor(private modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  confirmModal(yesNo: boolean): void {
    this.modal.close(yesNo);
  }

  dismissModal(): void {
    this.modal.dismiss();
  }

}
